import { useEffect, useState, useRef, useCallback } from "react";
import { Row, Col, message, Carousel } from "antd";
import { NavLink } from "react-router-dom";
import { GetAllNewsContent, GetNewsContent, PostNewsContent } from "./ajax";
import moment from "moment";
import { BottomIfor } from "./bottom/bottominfo";
import { ButtonforPh } from "./bottom/buttomforph";
import { Floatingpc } from "../components/floatingpc";
import { Floatingph } from "../components/floatingph";
function Notes(props) {
  useEffect(() => {
    window.addEventListener("scroll", function (e) {
      document.documentElement.style.overflow = "hidden";
    });
  }, []);

  const id = props.match.params.id || 0;

  return (
    <div className="newsactivitypage">
      <Title id={id} {...props} />
      <NewsContent id={id} {...props} />
    </div>
  );
}

function Title(props) {
  const [index, setIndex] = useState(0);
  const [shows, setShow] = useState(false);
  const [showmp, setShowmp] = useState(false);
  const [text, setText] = useState("一键复制QQ号");
  const showWindow = (a) => {
    setShow(a);
    setText("一键复制QQ号");
  };
  const showFloating = (e) => {
    setShowmp(true);
    e.nativeEvent.stopImmediatePropagation();
  };
  const hideFloating = (e) => {
    setShowmp(false);
    setText("一键复制QQ号");
  };
  useEffect(() => {
    document.addEventListener("touchstart", hideFloating);
  }, []);

  
  useEffect(() => {
    const IndexChange = {
      0: 0,
      1: 1,
      5: 2,
      6: 3,
    };
    setIndex(IndexChange[props.id * 1]);
  }, [props.id]);
  return (
    <div>
      <Row>
        <Col xs={0} sm={0} md={0} lg={24} xl={24}>
          <Floatingpc
            show={shows}
            showWindow={showWindow}
            text={text}
            setText={setText}
          />
          <div className="newspage-titlebox">
            <div className="newspagetitle-text">
              <div>
                NEWS <span>&</span> EVENTS
              </div>
              <div>近期新闻活动</div>
            </div>
          </div>
          <div className="newsnav">
            <div className="newsnav-box">
              <div
                style={{ left: `${index * 250 + 125}px` }}
                className="trangle-active"
              ></div>
              <NavLink to="/notes">
                <div>全部</div>
                <div>All EVENTS</div>
              </NavLink>
              <NavLink to="/notes/1">
                <div>KK幼儿园</div>
                <div>KK KINDERGARTEN</div>
              </NavLink>
              <NavLink to="/notes/5">
                <div>KK绘画社</div>
                <div>KK ART CLUB</div>
              </NavLink>
              <NavLink to="/notes/6">
                <div>KK训练营</div>
                <div>KK DRAWING CAMP</div>
              </NavLink>
            </div>
          </div>
        </Col>
        <Col xs={24} sm={24} md={24} lg={0} xl={0}>
          <Floatingph
            showmp={showmp}
            showFloating={showFloating}
            text={text}
            setText={setText}
          />
          <div className="newspage-titlebox-ph">
            <div className="newspagetitle-text-ph">
              <div>
                NEWS <span>&</span> EVENTS
              </div>
              <div>近期新闻活动</div>
            </div>
          </div>
          <div className="newsnav-ph">
            <div className="newsnav-box-ph">
              <NavLink
                to="/notes"
                className={`${index === 0 ? "trangle-activeph" : ""}`}
              >
                <div>全部</div>
                <div>All EVENTS</div>
              </NavLink>
              <NavLink
                to="/notes/1"
                className={`${index === 1 ? "trangle-activeph" : ""}`}
              >
                <div>KK幼儿园</div>
                <div>KK KINDERGARTEN</div>
              </NavLink>
              <NavLink
                to="/notes/5"
                className={`${index === 2 ? "trangle-activeph" : ""}`}
              >
                <div>KK绘画社</div>
                <div>KK ART CLUB</div>
              </NavLink>
              <NavLink
                to="/notes/6"
                className={`${index === 3 ? "trangle-activeph" : ""}`}
              >
                <div>KK训练营</div>
                <div>KK DRAWING CAMP</div>
              </NavLink>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
const arr = ["", "KK幼儿园", "KK魔法杯", "三宝活动室", "KK头条站",'KK绘画社','KK训练营','KK图书馆'];
const newsColorType = [
  "",
  "typegreen",
  "typepurple",
  "typeyellow",
  "typegray",
  "typepink",
  "typegreenblack",
  "typegreenblue",
];
const newsColorType2 = [
  "",
  "typegreen2",
  "typepurple2",
  "typeyellow2",
  "typegray2",
  "typepink2",
  "typegreenblack2",
  "typeblue2",
];

const newColorPh = [
  "",
  "typegreenph",
  "typepurpleph",
  "typeyellowph",
  "typegrayph",
  "typepinkph",
  "typegreenblackph",
  "typeblueph",
];

function NewsContent(props) {
  const [result, setData] = useState({
    pageSize: 0,
    pageNumber: 1,
    totalNumber: 0,
    data: [],
  });
  const [show, setShow] = useState(false);
  const [topnews, setTopNews] = useState([]);
  const slideimg = useRef();
  let { data } = result;
  let index = props.id;
  const prev = () => {
    slideimg && slideimg.current.prev();
  };
  const next = () => {
    slideimg && slideimg.current.next();
  };
  const load = useCallback(async () => {
    if (index === undefined) return;
    else {
      let res =
        index === 0
          ? await PostNewsContent()
          : await PostNewsContent({ newsType: index });
      if (res.code !== 0) {
        message.error(res.message);
        return;
      } else {
        setTopNews(res.data);
      }
    }
  }, [index]);
  const reload = useCallback(async (page, index, clear) => {
    if (index === undefined) return;
    else {
      let res =
        index === 0
          ? await GetAllNewsContent({ pageNumber: page, pageSize: 6, top: 0 })
          : await GetNewsContent(index, {
              pageNumber: page,
              pageSize: 6,
              top: 0,
            });
      if (res.code !== 0) {
        message.error(res.message);
        return;
      } else {
        setShow(true);
        let { pageSize, totalNumber } = res;
        if (
          Math.ceil(totalNumber / pageSize) === 0 ||
          Math.ceil(totalNumber / pageSize) === page
        ) {
          setShow(false);
        }
        setData((state) => {
          return {
            ...res,
            data: clear ? res.data : [...state.data, ...res.data],
          };
        });
      }
    }
  }, []);
  useEffect(() => {
    reload(1, index, true);
    load();
  }, [index, reload, load]);

  useEffect(() => {
    let trangle = document.querySelector(".home-content");
    let _pageNumber = 1;
    let timer = null;
    if (!show) return;
    trangle.onscroll = (e) => {
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        if (
          e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) <
          700
        ) {
          _pageNumber++;
          reload(_pageNumber, index);
        }
      }, 150);
    };
    return () => {
      trangle.onscroll = null;
    };
  }, [show, index, reload]);
  let settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    slidesToShow: 1,
    dots: false,
    adaptiveHeight: true,
  };

  return (
    <Row>
      <Col xs={0} sm={0} md={0} lg={24} xl={24}>
        <div className="newscontent">
          <div className="newsmiddle">
            <div className="newsmiddlecontent">
              {topnews.length > 0 ? (
                <div className="newstop">
                  <div
                    className="slide-arrow-left"
                    onClick={() => {
                      prev();
                    }}
                  ></div>
                  <div className="middleslidebox">
                    <Carousel {...settings} ref={slideimg}>
                      {topnews.map((i) => {
                        return (
                          <div
                            key={i.sort}
                            className="topnewsbox"
                            onClick={() => {
                              props.history.push(`/newsdetail/${i.id}`);
                            }}
                          >
                            <div>
                              <div className="newstopleft">
                                <img
                                  alt="jiazaizho"
                                  width="100%"
                                  height="100%"
                                  style={{ objectFit: "cover" }}
                                  src={i.newsImage}
                                />
                              </div>
                              <div className="newstopright">
                                <div>
                                  <div>
                                    <div
                                      className={`${newsColorType[i.newsType]}`}
                                    >
                                      {arr[i.newsType]}
                                    </div>
                                    <div>
                                      {moment(i.createTime * 1000).format(
                                        "YYYY .MM .DD"
                                      )}
                                    </div>
                                  </div>
                                  <div>{i.title}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Carousel>
                  </div>
                  <div
                    className="slide-arrow-right"
                    onClick={() => {
                      next();
                    }}
                  ></div>
                </div>
              ) : (
                ""
              )}
              <div style={{ width: 920, margin: "0 auto", paddingBottom: 50 }}>
                <div className="newbottom">
                  {data.map((i) => {
                    return (
                      <div
                        key={i.id}
                        className="newsbottmbox"
                        onClick={() => {
                          props.history.push(`/newsdetail/${i.id}`);
                        }}
                      >
                        <div className="newsbottomtopimg">
                          <img
                            alt="jiazaizho"
                            src={i.newsImage}
                            width="100%"
                            height="100%"
                            style={{ objectFit: "cover" }}
                          />
                        </div>
                        <div className="newsbottomtext">
                          <div>
                            <div className="tangandtime">
                              <div className={`${newsColorType2[i.newsType]}`}>
                                {arr[i.newsType]}
                              </div>
                              <div>
                                {moment(i.createTime * 1000).format(
                                  "YYYY .MM .DD"
                                )}
                              </div>
                            </div>
                            <div>{i.title}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div
                    className="more-fog"
                    style={show ? { display: "block" } : { display: "none" }}
                  >
                    <div>
                      <div>MORE</div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BottomIfor />
      </Col>
      <Col xs={24} sm={24} md={24} lg={0} xl={0}>
        <div className="newscontentph">
          <div className="newscontenttopph">
            {topnews.map((i) => {
              return (
                <div
                  key={i.id}
                  className="topnewsboxph"
                  onClick={() => {
                    props.history.push(`/newsdetail/${i.id}`, i);
                  }}
                >
                  <div className="newstopleftph">
                    <img
                      alt="jiazaizho"
                      src={i.newsImage}
                      width="100%"
                      height="100%"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  <div className="newstoprightph">
                    <div>
                      <div>
                        <div
                          className={`${
                            newColorPh[i.newsType]
                          }`}
                        >
                          {arr[i.newsType]}
                        </div>
                        <div>
                          {moment(i.createTime * 1000).format("YYYY .MM .DD")}
                        </div>
                      </div>
                      <div>{i.title}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="newscontentbottomph">
            {data
              .filter((i) => !i.top)
              .map((i) => {
                return (
                  <div
                    key={i.id}
                    className="newsbottmboxph"
                    onClick={() => {
                      props.history.push(`/newsdetail/${i.id}`, i);
                    }}
                  >
                    <div className="newsbottomtopimgph">
                      <img
                        alt="jiazaizho"
                        src={i.newsImage}
                        width="100%"
                        height="100%"
                        style={{ objectFit: "cover" }}
                      />
                    </div>
                    <div className="newsbottomtextph">
                      <div>
                        <div>
                          <div className={`${newColorPh[i.newsType]}`}>
                            {arr[i.newsType]}
                          </div>
                          <div>
                            {moment(i.createTime * 1000).format("YYYY .MM .DD")}
                          </div>
                        </div>
                        <div>{i.title}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            <div
              className="more-fog"
              style={show ? { display: "block" } : { display: "none" }}
            >
              <div>
                <div>MORE</div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <ButtonforPh />
      </Col>
    </Row>
  );
}
export default Notes;
